module.exports = __webpack_public_path__ + "static/media/nathalie.4ece5ef7.jpg";